
import orientationsLabelDef from '../json/orientations.json';

export function orientationLabels (ori, typeLabel = 'label') {
  // console.log(ori, orientationsLabelDef);
  return orientationsLabelDef[ori][typeLabel];
}